import { Component, Input, OnInit, inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { routeAnimations } from "@app/core";
import { SkillProfile } from "@app/models/rest/skill-profile";
import { SkillProfileStore } from "@app/services/store/skill-profile-store";
import { SkillProfileAddComponent } from "@app/view/setup/assignment/skill-profile-add/skill-profile-add.component";
import { BaseDataTablePageDirective } from "@app/view/shared/base-pages/base-data-table-page/base-data-table-page.directive";
import { SystemSearchMetaRestService } from "@app/services/hal/system-search-meta-rest.service";
import { UntypedFormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { RowExpanderConfig } from "@bryntum/grid-thin";
import { MatToolbar } from "@angular/material/toolbar";
import { MatButton } from "@angular/material/button";
import { GridComponent } from "../../../shared/base-pages/base-data-table-page/grid.component";
import { MatPaginator } from "@angular/material/paginator";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-skill-profile-list",
  templateUrl: "./skill-profile-list.component.html",
  styleUrls: ["./skill-profile-list.component.scss"],
  animations: [routeAnimations],
  imports: [MatToolbar, MatButton, GridComponent, MatPaginator, TranslatePipe]
})
export class SkillProfileListComponent
  extends BaseDataTablePageDirective<SkillProfile>
  implements OnInit
{
  skillProfileStore: SkillProfileStore;
  protected store: Store<any>;
  protected dialog: MatDialog;
  protected formBuilder: UntypedFormBuilder;
  protected router = inject(Router);
  serverErrorHandler: ServiceErrorHandlerService;
  protected ngxUiLoaderService: NgxUiLoaderService;

  @Input()
  public columns: object[] = [
    {
      field: "description",
      text: "Description",
      flex: 1,
      editor: true
    }
  ];
  rowExpanderConfig: Partial<RowExpanderConfig> = {
    columnPosition: "last",
    renderer: async ({ record }) => {
      console.log("Rendering skill profile card for record", record);
      const { id } = record;
      console.log("Extracted ID", id);
      return `<scheduler-skill-profile-detail skill-profile-id="${id}" style="width:100%"></scheduler-skill-profile-detail>`;
    }
  };

  constructor() {
    const systemSearchMetaRestService = inject(SystemSearchMetaRestService);
    const skillProfileStore = inject(SkillProfileStore);
    const store = inject<Store<any>>(Store);
    const dialog = inject(MatDialog);
    const formBuilder = inject(UntypedFormBuilder);
    const serverErrorHandler = inject(ServiceErrorHandlerService);
    const ngxUiLoaderService = inject(NgxUiLoaderService);

    super(
      systemSearchMetaRestService,
      skillProfileStore,
      store,
      dialog,
      "SkillProfile",
      formBuilder,
      serverErrorHandler,
      ngxUiLoaderService
    );

    this.skillProfileStore = skillProfileStore;
    this.store = store;
    this.dialog = dialog;
    this.formBuilder = formBuilder;
    this.serverErrorHandler = serverErrorHandler;
    this.ngxUiLoaderService = ngxUiLoaderService;
  }

  public get pristine() {
    return (
      !this.gridStore.changes ||
      (this.gridStore.changes.added.length === 0 &&
        this.gridStore.changes.removed.length === 0 &&
        this.gridStore.changes.modified.length === 0)
    );
  }

  ngOnInit() {
    super.ngOnInit();
    this.gridStore.autoCommit = false;
    this.gridStore.load({});
  }

  addRow() {
    this.gridStore.insert(0, {
      code: "",
      description: "",
      scoreWeight: 1
    });
  }

  openSkillProfileAddDialog(): void {
    const dialogRef = this.dialog.open(SkillProfileAddComponent);

    dialogRef.afterClosed().subscribe((result) => {
      console.log("The dialog was closed");
      console.log(result);
      this.ngOnInit();
    });
  }
}
